<template>
  <transition name="slide-fade" >
    <div id="academicsHolder" >
      <div v-show="pageLoad"   >
        <div class="uk-child-width-1-1" uk-grid>
          <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
            <div class="uk-container uk-container-small ">
              <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                {{ loadDegree.degreequote }}
              </p>
            </div>
          </div>-->
          <div class="uk-padding  uk-margin-remove-top" style="min-height: 85vh !important; background-color: rgb(187, 222, 251)">
            <div class="uk-container">
              <br><br>
              <h1 style="margin-bottom: 7px">{{ loadDegree.acf.program_name }},
                <span v-for="item in loadDegree.acf.program_level" style="font-size: 18px">{{ item }}</span>
              </h1>

              <div >
                <span class="uk-badge" v-for="item in loadDegree.acf.program_modality" style="background-color: rgb(255, 202, 40); color: black; padding: 0 10px">{{ item }}</span>
              </div>
              <br><br><br><br>
              <div  v-html="loadDegree.acf.program_overview" style="color: #111; font-weight: bold !important;"></div>
              <br><br>
              <div style="padding: 7px; background-color: white; border-radius: 5px">
                This programme is offered at: <span v-for="item in loadDegree.acf.campuses_offered" style="font-weight: bold">{{ item }}</span>
              </div>

              <br><br><br>
              <a class="uk-button uk-button-primary uk-button-small uk-border-none uk-border-rounded" target="_blank" href="https://apply.ncu.edu.jm" style="background-color: #033860; color: white">Apply Now</a>
            </div>

          </div>
        </div>
        <div class="uk-container" style="margin-top: -30px">
          <div class="uk-card uk-card-default uk-card-body">
            <div class="uk-child-width-1-3@m" uk-grid>
              <div style="text-align: center">
                <h4>Accreditation</h4>
                <div style="text-align: center">
                  <span class="uk-margin-small-right uk-text-success" uk-icon="icon: check; ratio: 1.5"></span>
                </div>
              </div>
              <div  style="text-align: center">
                <h4>Duration</h4>
                <div>{{ loadDegree.acf.program_duration }}</div>
              </div>
              <div  style="text-align: center">
                <h4>Tuition</h4>
                 <div>{{ "$" + loadDegree.acf.tuition_fees_jmd + ".00"}}</div>
<!--                <div >Local: <span style="font-weight: bold">$ {{ loadDegree.acf.tuition_fees_jmd }}.00</span></div>
                <div>Internation: <span style="font-weight: bold">$ {{ loadDegree.acf.tuition_fees_usd }}.00</span></div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="" style=" padding-top: 30px">
          <div class="uk-padding uk-container">
            <h2 style="color: #333 !important;">Programme Description</h2>
            <div>
              <div  v-html="loadDegree.acf.program_description"></div>
            </div>

          </div>
        </div>

        <div class=" " style="background-color: #F5F5F5; padding-top: 30px">
          <div class=" uk-container uk-padding">
            <h2 style="color: #333 !important; text-align: center">Matriculation Requirements</h2>
            <div uk-grid>
              <div class="uk-width-2-3@m" >
                <div v-html="loadDegree.acf.matriculation_requirements"></div>
              </div>
              <div class="uk-width-1-3@m">
                <img src="../assets/new_fix1.jpg" class="uk-border-rounded" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="uk-padding-large" style="background-color: rgb(255, 215, 3); margin-bottom: -80px">
          <div class=" uk-container ">
            <h2 style="color: #333 !important; text-align: center">Skills you will gain from this degree</h2>
            <div class="uk-child-width-1-3@m" uk-grid>
              <div v-for="item in loadDegree.acf.skills_you_will_learn">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!pageLoad" style="min-height: 90vh">

        <div class="uk-position uk-position-center ">
          <div uk-spinner="ratio: 3"></div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
    import UndergradLinks from "../components/undergrad/undergradLinks";

    export default {
        name: "undergradprogram",
      components: {UndergradLinks},
      data(){
        return {
          requirements: [],
          provisional: [],
          leavingWith: [],
          degreeCareers:[],
          pageLoad: false,
          emphasis: true
        }
      },
      computed: {

        loadDegree: function () {
          this.pageLoad = true
          return this.$store.state.undergradDegree[0]

        },
        loadRandomDegrees: function () {
          //this.pageLoad = true
          //console.log(this.$store.state.undergradDegrees.associate_degree)
          return this.$store.state.randomDegrees
        },

        degree:function (){
          this.degreeCareers = this.loadDegree.degreeCareers[0].split(',')
          console.log(this.degreeCareers)
          return this.degreeCareers
        },


        matriculate: function(){
          this.requirements = this.loadDegree.matriculationRequirements[0]
          console.log(this.requirements.regular)
          //this.requirements.pop()
          return this.requirements.regular
        },
        provisionalAccept: function(){
          this.provisional = this.loadDegree.provisional_requirements.split('*')
          this.provisional.pop()
          return this.provisional
        },

        beforeYouLeave: function () {
          this.leavingWith = this.loadDegree.graduantBenefit
          //this.leavingWith.pop()
          return this.leavingWith
        },
        step1: function () {
            const file = this.$store.state.cmsApiUrl + this.loadDegree.bg_image.bg1.replace(/\\/g,"/")
            //file.replace("\\","//")
            console.log(file)
            return {
                'background-image': `url(${file})`,
                'background-size': 'cover'
            }
        },
        step2: function () {
            const file = this.$store.state.cmsApiUrl + this.loadDegree.bg_image.bg2.replace(/\\/g,"/")
            return {
                'background-image': `url(${file})`,
                'background-size': 'cover'
            }
        },
        step3: function () {
            const file = this.$store.state.cmsApiUrl + this.loadDegree.bg_image.bg3.replace(/\\/g,"/")
            return {
                'background-image': `url(${file})`,
                'background-size': 'cover'
            }
        },
        step4: function () {
            const file = this.$store.state.cmsApiUrl + this.loadDegree.bg_image.bg4.replace(/\\/g,"/")
            return {
                'background-image': `url(${file})`,
                'background-size': 'cover'
            }
        }
      },
      methods: {
        findNewDegree: function(event){
          //this.$store.commit('getArticle', (event.target.id))
          //console.log(event.target)
          this.$router.push({ path: '/undergrad', query: { degree: event.target.id }})
          location.reload();
        },
      },
      created(){

      },
      mounted(){
        window.scrollTo(0, 0);
        this.$store.state.undergradDegree = []
        this.$store.state.degree.viewDegree = []
        /*},
        mounted(){*/
        //console.log(this.$store.state.viewArticle)
        window.scrollTo(0, 0);
        this.$store.dispatch('getNewDegree', {degree: this.$route.query.degree })

        this.$store.dispatch('getRandomDegrees')


      },
      beforeCreate(){

      }
    }
</script>

<style scoped>
  .uk-tab > .uk-active > a{
    font-weight: 600;
    color: rgb(197,179,88) !important;
  }
  h2, h4, h3{
    color: rgb(197,179,88) !important;
  }
  a{

  }
  #academicsHolder{
    min-height: 90vh;
  }
  [v-cloak] { display: none }
  /*.testStep{
    background-image: url('~@/assets/Degrees/CriminalJustice/bg2.jpg');
    background-size: cover;
  }
  .testStep1{
    background-image: url('~@/assets/Degrees/CriminalJustice/bg1.jpg');
    background-size: cover;
  }
  .testStep2{
    background-image: url('~@/assets/Degrees/CriminalJustice/bg4.jpg');
    background-size: cover;
  }
  .testStep3{
    background-image: url('~@/assets/Degrees/CriminalJustice/bg3.jpg');
    background-size: cover;
  }*/



</style>
